import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
const selectableColors = ["A", "B", "C", "D", "E", "F"] as const;

//Pass an optional variant so that we can access the surface/text colors & sublte colors
export const getEventColorKeyFromServerColor = (
  color: CustomColor,
  variant?: "surface" | "text"
) => {
  return variant
    ? `${variant}-user-selectable-color${color}`
    : `userSelectable.${color ?? "C"}`;
};

export const getSurfaceColor = (color: CustomColor): WhooshThemeColors =>
  selectableColors.includes(color)
    ? `surface-user-selectable-color${color}-subtle`
    : "grayscale-200";

export const getLightSurfaceColor = (color: CustomColor): WhooshThemeColors =>
  selectableColors.includes(color)
    ? `surface-user-selectable-color${color}-subtlest`
    : "grayscale-200";

export const getTextColor = (color: CustomColor): WhooshThemeColors =>
  selectableColors.includes(color)
    ? `text-user-selectable-color${color}-inverse`
    : "text-primary";
